import {
  Link,
  useParams,
} from "react-router-dom";

import {
  FaMapMarkerAlt,
  FaClock,
  FaDollarSign,
  FaHospital,
  FaBriefcaseMedical,
  FaCalendarAlt,
} from "react-icons/fa";

import PublicLayout from "../layouts/PublicLayout";

import assignments from "../data/assignments";


function formatDate(
  dateValue,
  includeTime = false
) {
  if (!dateValue) {
    return "";
  }

  const date =
    new Date(dateValue);

  return date.toLocaleDateString(
    "en-CA",
    includeTime
      ? {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }
      : {
          month: "short",
          day: "numeric",
          year: "numeric",
        }
  );
}


function getPayDisplay(
  assignment
) {
  if (
    assignment.payDisplay
  ) {
    return assignment.payDisplay;
  }

  if (
    assignment.pay !== null &&
    assignment.pay !== undefined
  ) {
    return `$${assignment.pay}/hour`;
  }

  return "Rate available upon offer";
}


function AssignmentDetails() {
  const { id } =
    useParams();


  const assignment =
    assignments.find(
      (item) =>
        item.id ===
        Number(id)
    );


  if (!assignment) {
    return (
      <PublicLayout>
        <section className="assignment-detail-section">
          <div className="assignment-detail-container">
            <div className="assignment-not-found">
              <h1>
                Assignment not
                found
              </h1>

              <p>
                The assignment may
                no longer be
                available.
              </p>

              <Link
                className="primary-button"
                to="/#assignments"
              >
                Browse Assignments
              </Link>
            </div>
          </div>
        </section>
      </PublicLayout>
    );
  }


  return (
    <PublicLayout>
      <section className="assignment-detail-section">
        <div className="assignment-detail-container">
          <div className="assignment-detail-main">
            <div className="assignment-detail-header">
              <span
                className={`assignment-status ${assignment.status.toLowerCase()}`}
              >
                {
                  assignment.status
                }
              </span>

              <span className="assignment-profession">
                {
                  assignment.profession
                }
              </span>

              <h1>
                {assignment.title}
              </h1>

              <p>
                {
                  assignment.facility
                }
              </p>
            </div>


            <div className="assignment-detail-info">
              <span>
                <FaMapMarkerAlt />

                {
                  assignment.city
                }
                ,{" "}
                {
                  assignment.province
                }
              </span>


              {assignment.unit && (
                <span>
                  <FaBriefcaseMedical />

                  {
                    assignment.unit
                  }
                </span>
              )}


              <span>
                <FaClock />

                {
                  assignment.shift
                }{" "}
                shift
              </span>


              <span>
                <FaDollarSign />

                {getPayDisplay(
                  assignment
                )}
              </span>


              <span>
                <FaHospital />

                {
                  assignment.facility
                }
              </span>


              {assignment.startDate &&
                assignment.endDate && (
                  <span>
                    <FaCalendarAlt />

                    {formatDate(
                      `${assignment.startDate}T12:00:00`
                    )}{" "}
                    –{" "}
                    {formatDate(
                      `${assignment.endDate}T12:00:00`
                    )}
                  </span>
                )}
            </div>


            <div className="assignment-detail-content">
              <h2>
                Assignment overview
              </h2>

              <p>
                {
                  assignment.description
                }
              </p>


              {assignment.startDate &&
                assignment.endDate && (
                  <>
                    <h2>
                      Contract dates
                    </h2>

                    <p>
                      {formatDate(
                        `${assignment.startDate}T12:00:00`
                      )}{" "}
                      to{" "}
                      {formatDate(
                        `${assignment.endDate}T12:00:00`
                      )}
                    </p>
                  </>
                )}


              {assignment.closingDate && (
                <>
                  <h2>
                    Application deadline
                  </h2>

                  <p>
                    {formatDate(
                      assignment.closingDate,
                      true
                    )}
                  </p>
                </>
              )}


              <h2>
                Requirements
              </h2>

              <ul>
                {assignment.requirements.map(
                  (
                    requirement
                  ) => (
                    <li
                      key={
                        requirement
                      }
                    >
                      {
                        requirement
                      }
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>


          <aside className="assignment-apply-card">
            <h2>
              Interested in this
              assignment?
            </h2>

            <p>
              Sign in or create a
              professional account
              to submit your
              application.
            </p>


            <div className="assignment-apply-rate">
              <span>
                Professional
                compensation
              </span>

              <strong>
                {getPayDisplay(
                  assignment
                )}
              </strong>
            </div>


            {assignment.startDate &&
              assignment.endDate && (
                <div className="assignment-apply-dates">
                  <span>
                    Contract period
                  </span>

                  <strong>
                    {formatDate(
                      `${assignment.startDate}T12:00:00`
                    )}
                    {" – "}
                    {formatDate(
                      `${assignment.endDate}T12:00:00`
                    )}
                  </strong>
                </div>
              )}


            <Link
              className="primary-button assignment-apply-button"
              to="/professional/login"
            >
              Apply Now
            </Link>


            <Link
              className="secondary-button assignment-register-button"
              to="/professional/register"
            >
              Create Account
            </Link>


            <Link
              className="assignment-back-link"
              to="/#assignments"
            >
              ← Back to assignments
            </Link>
          </aside>
        </div>
      </section>
    </PublicLayout>
  );
}


export default AssignmentDetails;